"use strict";
Object.defineProperty(exports, "__esModule", {
    value: !0
}), Object.defineProperty(exports, "NetworkError", {
    enumerable: !0,
    get: function() {
        return NetworkError;
    }
});
class NetworkError extends Error {
}

//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9odHRwL05ldHdvcmtFcnJvci50cyJdLCJzb3VyY2VzQ29udGVudCI6WyIvKipcbiAqIEVycm9yIHR5cGUgZm9yIGNhcHR1cmluZyBuZXR3b3JrIGVycm9ycy5cbiAqL1xuXG5leHBvcnQgY2xhc3MgTmV0d29ya0Vycm9yIGV4dGVuZHMgRXJyb3Ige31cbiJdLCJuYW1lcyI6WyJOZXR3b3JrRXJyb3IiLCJFcnJvciJdLCJtYXBwaW5ncyI6Ijs7O21DQUlhQTs7O2VBQUFBOzs7QUFBTixNQUFNQSxxQkFBcUJDO0FBQU8ifQ==